var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7313_4122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7313_4122)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D7E1E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 11,
    width: 17.3333,
    height: 17.3333,
    rx: 8.66667,
    fill: "#7A999E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 45.5771C35.4879 48.4862 32.9162 50.668 25.0001 50.668C17.084 50.668 14.8619 48.8498 10.6667 45.5771C10.6667 39.9538 17.084 30.668 25.0001 30.668C32.9162 30.668 39.3334 39.9538 39.3334 45.5771Z",
    fill: "#7A999E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.f93fc858aad005b94a523f744cc90b3f.svg";
export { ForwardRef as ReactComponent };